import noTokenRequest from '@/utils/request/noTokenRequest'
import correctionV1_api from '@/utils/request/correctionV1_api'
import manual_correction_portfolio_composition_api from '@/utils/request/manual_correction_portfolio_composition_api'
import manual_correction_group_composition_request from '@/utils/request/manual_correction_group_composition_request'
import rePi_api from '@/utils/request/rePi_api'
import aicourseRequest from '@/utils/request/aicourseRequest'
export function query_option_by_set_id_and_feature_code(data) {
    return noTokenRequest({
        url: '/console/query_option_by_set_id_and_feature_code',
        method: 'post',
        data,
    });
}
export function re_ai_evaluation(data) {
    return rePi_api({
        url: '/console/re_ai_evaluation',
        method: 'post',
        data,
    });
}
export function re_ai_write(data) {
    return rePi_api({
        url: '/console/re_ai_write',
        method: 'post',
        data,
    });
}

export function query_plan_join_report_by_plan_id_class_id_romm_id(data) {
    return noTokenRequest({
        url: '/console/query_plan_join_report_by_plan_id_class_id_romm_id',
        method: 'post',
        data,
    });
}
export function query_entity(data) {
    return noTokenRequest({
        url: '/console/query_entity',
        method: 'post',
        data,
    });
}
export function update_entity(data) {
    return noTokenRequest({
        url: '/console/update_entity',
        method: 'post',
        data,
    });
}
export function query_submited_and_not_submited_student_by_class_id_and_plan_id(data) {
    return noTokenRequest({
        url: '/console/query_submited_and_not_submited_student_by_class_id_and_plan_id',
        method: 'post',
        data
    })
}
export function get_group_list_by_class_id(data) {
    return noTokenRequest({
        url: '/console/get_group_list_by_class_id',
        method: 'post',
        data,
    });
}
export function query_courseware(data) {
    return noTokenRequest({
        url: '/console/query_courseware',
        method: 'post',
        data,
    });
}
export function create_entity(data) {
    return noTokenRequest({
        url: '/console/create_entity',
        method: 'post',
        data,
    });
}
export function manual_correctionV1(data) {
    return correctionV1_api({
        url: '/manual_correction/manual_correctionV1',
        method: 'post',
        data,
    });
}
export function manual_correction_portfolio_composition(data) {
    return manual_correction_portfolio_composition_api({
        url: '/manual_correction/manual_correction_portfolio_composition',
        method: 'post',
        data,
    });
}
export function manual_correction_group_composition(data) {
    return manual_correction_group_composition_request({
        url: '/manual_correction/manual_correction_group_composition',
        method: 'post',
        data,
    });
}
export function get_plan_join_detaill_by_plan_id(data) {
    return noTokenRequest({
        url: '/console/get_plan_join_detaill_by_plan_id',
        method: 'post',
        data,
    });
}
export function get_plan_join_detaill(data) {
    return noTokenRequest({
        url: '/console/get_plan_join_detaill',
        method: 'post',
        data,
    });
}

export function get_student_list_by_class_id(data) {
    return noTokenRequest({
        url: '/console/get_student_list_by_class_id',
        method: 'post',
        data,
    });
}
export function get_plan_ai_composition_by_id(data) {
    return noTokenRequest({
        url: '/console/get_plan_ai_composition_by_id',
        method: 'post',
        data,
    });
}
export function get_plan_ai_composition_by_user_id(data) {
    return noTokenRequest({
        url: '/console/get_plan_ai_composition_by_user_id',
        method: 'post',
        data,
    });
}
export function create_plan_ai_composition(data) {
    return noTokenRequest({
        url: '/console/create_plan_ai_composition',
        method: 'post',
        data,
    });
}
export function get_layout_by_set_id(data) {
    return noTokenRequest({
        url: '/console/get_layout_by_set_id',
        method: 'post',
        data
    })
}
export function load_html_from_oss(data) {
    return aicourseRequest({
        url: '/api/question/load-html',
        method: 'post',
        data
    })
}
export function save_courseware_html(data) {
    return aicourseRequest({
        url: '/api/courseware/save-html',
        method: 'post',
        data
    })
}


// 按 question_id 获取工具箱列表(与学生端 getQuestionToolkit 同一 console 接口)
export function getQuestionToolkit(data) {
    return noTokenRequest({
        url: '/console/query_question_toolkit',
        method: 'post',
        data,
    })
}
